import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";
import { v4 as uuidv4 } from 'uuid';

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

export function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}
function GetClientServiceAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    Rejected: item.rejected,
    Uid: item.uid,
    
  };

  return client.post("Common/GetClientServiceAccidents", prepareRequest(data));
}

function GetRespUserAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    NewClaim: item.newClaim,
    NoResponsible: item.noResponsible,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize
  };
  return client.post("Common/GetRespUserAccidents", prepareRequest(data));
}

function GetCommAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    CommFinish: item.commFinish
  };
  return client.post("Common/GetCommAccidents", prepareRequest(data));
}

function GetCommAllAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    CommFinish: item.commFinish,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize,
    DataExport: item.dataExport,
  };
  return client.post("Common/GetCommAllAccidents", prepareRequest(data));
}

function GetAccidentResults(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText
  };
  return client.post("Common/GetAccidentResults", prepareRequest(data));
}

function GetClaimParticipants(id) {
  const data = { AccidentId: id };
  return client.post("Common/GetClaimParticipants", prepareRequest(data));
}

function GetClaimParticipant(id) {
  const data = { ClaimId: id };
  return client.post("Common/GetClaimParticipant", prepareRequest(data));
}

function FileUploadStatus(id) {
  const data = { ClaimId: id };
  return client.post("Common/FileUploadStatus", prepareRequest(data));
}

function GetClaimsTechExpert(item) {
  const data = {
    MyData: item.myData,
    NoResponsible: item.noResponsible,
    StartExpert: item.startExpert,
    Status: item.status,
    Uid: item.uid
  };
  return client.post("Common/GetClaimsTechExpert", prepareRequest(data));
}

function GetClaimsLegalExpert(myData, startExpert, uid) {
  const data = {
    MyData: myData,
    StartExpert: startExpert,
    CommandUserId: uid
  };
  return client.post("Common/GetClaimsLegalExpert", prepareRequest(data));
}

function GetClaimActPrint(id) {
  const data = { ClaimId: id };
  return client.post("Common/GetClaimActPrint", prepareRequest(data));
}

function AccidentStatusAlert() {
  return client.post("Common/AccidentStatusAlert", prepareRequest({}));
}

function GetClientServiceActiveAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    NoResponsible: item.noResponsible
  };
  return client.post("Common/GetClientServiceActiveAccidents", prepareRequest(data));
}

function GetTechExpertPending(item) {
  const data = {
    MyData: item.myData,
    CommandUserId: item.commandUserId,
    Type: item.type
  };
  return client.post("Common/GetTechExpertPending", prepareRequest(data));
}

function GetActiveClaimsTechExpert(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    MyData: item.myData,
    NoResponsible: item.noResponsible,
    StartExpert: item.startExpert,
    PendingApproval: item.pendingApproval,
    Rejected: item.rejected,
    CommandUserId: item.commandUserId,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize
  };
  return client.post("Common/GetActiveClaimsTechExpert", prepareRequest(data));
}

function GetAllClaimsTechExpert(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    MyData: item.myData,
    NoResponsible: item.noResponsible,
    StartExpert: item.startExpert,
    CommandUserId: item.commandUserId,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize
  };
  return client.post("Common/GetAllClaimsTechExpert", prepareRequest(data));
}

function GetAllClaimsLegalExpert(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    MyData: item.myData,
    NoResponsible: item.noResponsible,
    StartExpert: item.startExpert,
    Status: item.status,
    CommandUserId: item.commandUserId
  };
  return client.post("Common/GetAllClaimsLegalExpert", prepareRequest(data));
}

function GetClientServiceAllAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText,
    NoResponsible: item.noResponsible,
    NewClaim: item.newClaim,
    Rejected: item.rejected,
    PageNumber: item.pageNumber,
    PageSize: item.pageSize,
    DataExport: item.dataExport
  };
  return client.post("Common/GetClientServiceAllAccidents", prepareRequest(data));
}

function GetRepairStages(claimId, actType) {
  const data = { ClaimId: claimId, ActType: actType };
  return client.post("Common/GetRepairStages", prepareRequest(data));
}

function CreateRepairStage(item) {
  return client.post("Common/RepairStageInsert", prepareDataRequest(item));
}

function UpdateRepairStage(item) {
  return client.post("Common/RepairStageUpdate", prepareDataRequest(item));
}

function DeleteRepairStage(id, claimId, uid, actType) {
  const data = { Id: id, ClaimId: claimId, CommandUserId: uid, ActType: actType };
  return client.post("Common/RepairStageDelete", prepareDataRequest(data));
}

function GetSpareParts(claimId, actType) {
  const data = { ClaimId: claimId, ActType: actType };
  return client.post("Common/GetSpareParts", prepareRequest(data));
}

function CreateSparePart(item) {
  return client.post("Common/SparePartInsert", prepareDataRequest(item));
}

function UpdateSparePart(item) {
  return client.post("Common/SparePartUpdate", prepareDataRequest(item));
}

function DeleteSparePart(id, claimId, uid, actType) {
  const data = { Id: id, ClaimId: claimId, CommandUserId: uid, ActType: actType };
  return client.post("Common/SparePartDelete", prepareDataRequest(data));
}

function RepairStagesTotalSum(claimId, actType) {
  const data = { ClaimId: claimId, actType: actType };
  return client.post("Common/RepairStagesTotalSum", prepareRequest(data));
}

function GetClientServiceActiveClaims(item) {
  const data = {
    MyData: item.myData,
    Status: item.status,
    User: item.commandUserId
  };
  return client.post("Common/GetClientServiceActiveClaims", prepareRequest(data));
}

function GetMedExpert(claimId) {
  const data = { ClaimId: claimId };
  return client.post("Common/GetMedExpert", prepareRequest(data));
}

function SendToMedExpert(id, uid) {
  const data = { Id: id, CommandUserId: uid };
  return client.post("Common/SendToMedExpert", prepareDataRequest(data));
}

function UpdateMedExpert(item) {
  return client.post("Common/MedExpertUpdate", prepareDataRequest(item));
}

function CheckStatusCount(accidentId, claimId, status) {
  const data = { AccidentId: accidentId, ClaimId: claimId, Status: status };
  return client.post("Common/CheckStatusCount", prepareRequest(data));
}

function GetAccidentsStatus(accidentId, claimId) {
  const data = { AccidentId: accidentId, ClaimId: claimId };
  return client.post("Common/GetAccidentsStatus", prepareRequest(data));
}

function PolicyStatusInsert(item) {
  return client.post("Common/PolicyStatusInsert", prepareDataRequest(item));
}

function GetForm4AllAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText
  };
  return client.post("Common/GetForm4AllAccidents", prepareRequest(data));
}

function CreateParticipantReport(item) {
  return client.post("Common/ParticipantReportInsert", prepareDataRequest(item));
}

function UpdateParticipantReport(item) {
  return client.post("Common/ParticipantReportUpdate", prepareDataRequest(item));
}

function GetParticipantReport(id) {
  const data = { Id : id };
  return client.post("Common/GetParticipantReport", prepareRequest(data));
}

function CreateRepairCenter(item) {
  return client.post("Common/RepairCenterInsert", prepareDataRequest(item));
}

function UpdateRepairCenter(item) {
  return client.post("Common/RepairCenterUpdate", prepareDataRequest(item));
}

function GetRepairCenter(claimId) {
  const data = { ClaimId: claimId };
  return client.post("Common/GetRepairCenter", prepareRequest(data));
}

function CheckDuplicateParticipant(accidentId, regNumber, damageType) {
  const data = { AccidentId: accidentId, RegNumber: regNumber, DamageType: damageType };
  return client.post("Common/CheckDuplicateParticipant", prepareDataRequest(data));
}

function CreateCommUnSign(item) {
  return client.post("Common/CommUnSignInsert", prepareDataRequest(item));
}

function GetCommUnSign(accidentId) {
  const data = { AccidentId: accidentId };
  return client.post("Common/GetCommUnSign", prepareRequest(data));
}

function GetOppositeSide(id) {
  const data = { Id: id };
  return client.post("Common/GetOppositeSide", prepareRequest(data));
}

function GetOppositeSides(accidentId) {
  const data = { AccidentId : accidentId };
  return client.post("Common/GetOppositeSides", prepareRequest(data));
}

function CreateOppositeSide(item) {
  return client.post("Common/OppositeSideInsert", prepareDataRequest(item));
}

function UpdateOppositeSide(item) {
  return client.post("Common/OppositeSideUpdate", prepareDataRequest(item));
}

function DeleteOppositeSide(id, uid) {
  const data = { AccidentId: id, CommandUserId: uid };
  return client.post("Common/OppositeSideDelete", prepareDataRequest(data));
}

function LastAccidentStatus(id) {
  const data = { AccidentId: id };
  return client.post("Common/LastAccidentStatus", prepareRequest(data));
}

function GetCommReject(accidentId, type) {
  const data = { AccidentId: accidentId, Type: type };
  return client.post("Common/GetCommReject", prepareRequest(data));
}

function GetClientUserAccidentCount() {
  return client.post("Common/GetClientUserAccidentCount", prepareRequest({}));
}

function GetRecentAccident(regNumber) {
  const data = { RegNumber: regNumber };
  return client.post("Common/GetRecentAccident", prepareRequest(data));
}

function GetTechExpertAccidents(item) {
  const data = {
    DtFrom: item.startDate,
    DtTo: item.endDate,
    SearchType: item.searchType,
    SearchText: item.searchText === "" ? null : item.searchText
  };
  return client.post("Common/GetTechExpertAccidents", prepareRequest(data));
}

function LastAssessmentStatus(claimId) {
  const data = { ClaimId: claimId };
  return client.post("Common/LastAssessmentStatus", prepareRequest(data));
}

function CreateAccidentStatusNote(item) {
  return client.post("Common/AccidentStatusNoteInsert", prepareDataRequest(item));
}

function DeleteAccidentStatusNote(note) {
  const data = { Id: note.id, CommandUserId: note.uid };
  return client.post("Common/AccidentStatusNoteDelete", prepareDataRequest(data));
}

function GetAccidentsStatusNote(statusId) {
  const data = { StatusId: statusId };
  return client.post("Common/GetAccidentsStatusNote", prepareRequest(data));
}

function AccidentStatusNoteUpdate(note) {
  const data = { Id: note.id, Status: note.status, CommandUserId: note.uid };
  return client.post("Common/AccidentStatusNoteUpdate", prepareDataRequest(data));
}

function NotesStatusCount(type, id) {
  const data = { Type: type, Id: id };
  return client.post("Common/NotesStatusCount", prepareRequest(data));
}

function SearchRegion(placeName) {
  const data = {
    placeName: placeName
  };
  return client.post("Common/SearchRegion", prepareRequest(data));
}

export {
  GetClientServiceAccidents, GetCommAccidents, GetClaimParticipants, GetClaimParticipant, FileUploadStatus, GetClaimsTechExpert, GetClaimsLegalExpert,
  GetClaimActPrint, AccidentStatusAlert, GetClientServiceActiveAccidents, GetTechExpertPending, GetAllClaimsTechExpert, GetAllClaimsLegalExpert,
  GetClientServiceAllAccidents, GetRepairStages, CreateRepairStage, DeleteRepairStage, GetSpareParts, CreateSparePart,
  DeleteSparePart, UpdateRepairStage, UpdateSparePart, RepairStagesTotalSum, GetClientServiceActiveClaims, SendToMedExpert,
  UpdateMedExpert, GetMedExpert, CheckStatusCount, GetCommAllAccidents, GetRespUserAccidents, GetAccidentResults, GetAccidentsStatus, PolicyStatusInsert,
  GetForm4AllAccidents, CreateParticipantReport, UpdateParticipantReport, GetParticipantReport, CreateRepairCenter, GetRepairCenter,
  UpdateRepairCenter, CheckDuplicateParticipant, CreateCommUnSign, GetCommUnSign, GetOppositeSide, GetOppositeSides, CreateOppositeSide,
  UpdateOppositeSide, DeleteOppositeSide, LastAccidentStatus, GetCommReject, GetClientUserAccidentCount, GetRecentAccident, GetTechExpertAccidents,
  LastAssessmentStatus, GetActiveClaimsTechExpert, CreateAccidentStatusNote, DeleteAccidentStatusNote, GetAccidentsStatusNote, AccidentStatusNoteUpdate, NotesStatusCount,
  SearchRegion
};